export const BASE_CLASS = 'mt-HeroDealer'

export const NO_OP = () => {}

export const LOGO_IMG_HEIGHT = 63
export const LOGO_IMG_WIDTH = 125

export const TYPE = {
  DEFAULT: 'default',
  INFORMATIVE: 'informative'
}

export const DESIGN = {
  DEFAULT: 'default',
  COMPRESSED: 'compressed'
}
